import React, { useEffect, useState } from "react";
import styles from "./Product.module.css";
import { useAuth } from "../../components/context/Auth";
import TopTabBar from "../../components/updatedComponents/Tanolet/TopTabBar";
import DropDown from "../../components/updatedComponents/FormComponents/DropDown";
import ImageUploder from "../../components/updatedComponents/Product/ImageUploder";
import InputTag from "../../components/updatedComponents/FormComponents/InputTag";
import KeyWordGen from "../../components/updatedComponents/Product/KeyWordGen";
import InputTextArea from "../../components/updatedComponents/Product/InputTextArea";
import InputRedio from "../../components/updatedComponents/FormComponents/InputRedio";
import Button from "../../components/updatedComponents/Dealers/Button";
import { AddTO, DeleteTo } from "../../components/icons/Icon3";
import DrawerWrapper from "../../components/updatedComponents/layoutWrapper/DrawerWrapper";
import { useToast } from "../../components/updatedComponents/Toaster/Toaster";
import { handleFileData } from "../../APIsControll/apiControl2";
import { useNavigate, useParams } from "react-router-dom";
import VerticalDropDown2 from "../../components/updatedComponents/FormComponents/VerticalDropDown2";
import fetchData from "../../APIsControll/apiControll";
import Skeleton from "../../components/updatedComponents/Skeleton/Skeleton";
import { validateFormForAddUpdateCollection } from "../../validation/AddDealer";

const AddCollection = () => {
  const { show } = useToast();
  const { mode } = useAuth();
  const { productName } = useParams()
  const productId = new URLSearchParams(window.location.search).get("productId");
  const collectionId = new URLSearchParams(window.location.search).get("collectionId");
  const [modelContainer, setmodelContainer] = useState(null);
  const [toggle, setToggle] = useState({ modelToggle: false });
  const [ProductType, setProductType] = useState([]);
  // const [selectedTypes, setSelectedTypes] = useState([]);
  const [errors, setErrors] = useState({});
  const [url, seturl] = useState("");
  const [loading, setLoading] = useState({ getTypeloading: false, updateLoading: false });

  const navigate = useNavigate()
  const [SingleData, setSingleData] = useState({
    product_name: "",
    product_id: "",
    type_name: [{}],
    collection_name: "",
    logo: "",
    metaTitle: "",
    metaKeywords: [],
    focusKeyword: [],
    url: "",
    mrp: "",
    title: "",
    description: "",
    metaDescription: "",
    status: "",
    size: "",
    DeskTopBanner: [],
    mobItemBanner: [],
    accessories: [{}],
  });

  // set Meta url
  useEffect(() => {
    const formatUrlFromMetaTitle = (metaTitle) => {
      return metaTitle.replace(/\s+/g, " ").split(" ").join("-").toLowerCase();
    };
    const formattedUrl = formatUrlFromMetaTitle(SingleData.metaTitle);
    seturl(formattedUrl);
  }, [SingleData]);

  // Create DeskTop
  const addNewDeskTopBanner = () => {
    setSingleData((prevData) => ({
      ...prevData,
      DeskTopBanner: [
        ...prevData.DeskTopBanner,
        {
          bannerImg: "",
          itemUrl: "",
          itemUrlType: "",
        },
      ],
    }));
  };

  // Create Mobile
  const addNewMobileBanner = () => {
    setSingleData((prevData) => ({
      ...prevData,
      mobItemBanner: [
        ...prevData.mobItemBanner,
        {
          bannerImg: "",
          itemUrl: "",
          itemUrlType: "",
        },
      ],
    }));
  };

  // set Desktop and Mobile Image
  const handleImageChange = (bannerType, index, imageUrl) => {
    const updatedBanner = [...SingleData[bannerType]];
    updatedBanner[index].bannerImg = imageUrl;
    setSingleData({
      ...SingleData,
      [bannerType]: updatedBanner,
    });
  };

  const handleAddAccessory = () => {
    const newAccessory = { id: SingleData.type_name.length + 1, };
    setSingleData({
      ...SingleData,
      type_name: [...SingleData.type_name, newAccessory],
    });
  };

  const handleRemoveAccessory = (index) => {
    setSingleData({
      ...SingleData,
      type_name: SingleData.type_name.filter((_, i) => i !== index),
    });

  };

  const getCollection = async () => {
    try {
      setLoading({ ...loading, getTypeloading: true });
      const payload = {
        product_id: productId,
        _id: collectionId ? collectionId : "",
      };
      const res = await fetchData(`content/collection`, payload);
      if (res.status === "success") {
        setProductType(res.types);
        setSingleData({
          ...SingleData,
          collection_name: res?.data?.collection_name ? res?.data?.collection_name : "",
          product_name: res?.data?.product_name ? res?.data?.product_name : "",
          DeskTopBanner: res?.data?.banner ? res?.data?.banner : [],
          mobItemBanner: res?.data?.mobBanner ? res?.data?.mobBanner : [],
          size: res?.data?.size ? res?.data?.size : "",
          logo: res?.data?.logo ? res?.data?.logo : "",
          title: res?.data?.title ? res?.data?.title : "",
          description: res?.data?.description ? res?.data?.description : "",
          metaTitle: res?.data?.metaTitle ? res?.data?.metaTitle : "",
          metaDescription: res?.data?.metaDescription ? res?.data?.metaDescription : "",
          metaKeywords: res?.data?.metaKeywords ? res?.data?.metaKeywords : "",
          focusKeyword: res?.data?.focusKeyword ? [res?.data?.focusKeyword] : [],
          status: res?.data?.status ? res?.data?.status : "",
          mrp: res?.data?.mrp ? res?.data?.mrp : "",
          type_name: Array.isArray(res?.data?.type_name)
            ? res.data.type_name.map((name) => ({
              label: name,
              value: name,
            }))
            : [{}],
        });
        seturl(res?.data?.url);
      };
    } catch (error) {
    } finally {
      setLoading({ ...loading, getTypeloading: false });
    }
  };

  const NewPrductCreate = async () => {
    const validationErrors = validateFormForAddUpdateCollection(SingleData);
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    setLoading({ ...loading, updateLoading: true });
    try {
      const formdata = new FormData();
      formdata.append("product_name", productName);
      formdata.append("collection_name", SingleData.collection_name);
      formdata.append("product_id", productId);
      formdata.append("logo", SingleData.logo);
      formdata.append("metaTitle", SingleData.metaTitle);
      formdata.append("metaKeywords", JSON.stringify(SingleData.metaKeywords));
      formdata.append("focusKeyword", SingleData.focusKeyword[0]);
      formdata.append("url", url);
      formdata.append("mrp", Number(SingleData.mrp));
      formdata.append("title", SingleData.title);
      formdata.append("description", SingleData.description);
      formdata.append("metaDescription", SingleData.metaDescription);
      formdata.append("status", SingleData.status);
      formdata.append("size", SingleData.size);
      formdata.append("type_name", JSON.stringify(SingleData.type_name.map((item) => item.value)));
      SingleData?.DeskTopBanner.forEach((item) => {
        formdata.append("bannerImg", item.bannerImg);
        formdata.append("itemUrl", item.itemUrl);
        formdata.append("itemUrlType", item.itemUrlType);
      });
      SingleData.mobItemBanner.forEach((item) => {
        formdata.append("mobBannerImg", item.bannerImg);
        formdata.append("mobItemUrl", item.itemUrl);
        formdata.append("mobItemUrlType", item.itemUrlType);
      });

      formdata.append("bannerUpdate", "");
      formdata.append("mobBannerUpdate", "");
      collectionId && formdata.append("_id", collectionId);

      const res = await handleFileData("content/addUpdateCollection", formdata);
      if (res.status === "success") {
        show(res.msg || res.message || res.data, "success");
        navigate(-1)
        return;
      }
      if (res.status === "failed") {
        show(res.msg || res.message, "error");
        return;
      } else {
        show("Error", "error");
      }
    } catch (error) {
      //console.log(error);
    } finally {
      setLoading({ ...loading, updateLoading: false });
    }
  };
  const HandelRemoveDeskTopBanner = (index) => {
    const updatedList = SingleData.DeskTopBanner.filter((_, i) => i !== index);
    setSingleData({
      ...SingleData,
      DeskTopBanner: updatedList,
    });
  };
  const HandelRemoveMobItemBanner = (index) => {
    const updatedList = SingleData.mobItemBanner.filter((_, i) => i !== index);
    setSingleData({
      ...SingleData,
      mobItemBanner: updatedList,
    });
  };


  useEffect(() => {
    getCollection();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  return (
    <div className={styles.Main_Layout}>
      <DrawerWrapper
        isOpen={toggle.modelToggle}
        onClose={() => setToggle({ ...toggle, modelToggle: false })}
      >
        {modelContainer}
      </DrawerWrapper>
      <div
        className={styles.Layout}
        style={{
          backgroundColor: mode ? "#2B2D31" : "#F8F9FC",
          color: mode? "#fff"  : "#000" /* cursor: disabled ? "not-allowed" : "" */,
        }}
      >
        {/* <form> */}
        <div className={styles.Top_bar_css}>
          <div className={styles.gobackClass}>
            <TopTabBar text={`Product / ${productName}`} />
          </div>
          <div className={styles.btn_Continer}>
            <div style={{ width: "120px", }}>
              <Button
                buttonText={collectionId ? "Update" : "Create"}
                buttonBgColor={"#4164E3"}
                buttonTextColor={"#fff"}
                buttonIcon={<AddTO />}
                disabledButtonTextColor={"#fff"}
                disabledButtonBgColor={"#4164E3"}
                buttonClick={NewPrductCreate}
                loading={loading.updateLoading}
              />
            </div>
          </div>
        </div>

        <div className={styles.form_continer}>
          {/* col - 1 */}
          <div className={styles.Col_sm}>
            <InputTag
              labelText={"Meta URL"}
              star={true}
              padding={"8px"}
              fontSize={"12px"}
              maxLength={10000}
              placeholderType={"text"}
              required={true}
              value={url}
              disabled={true}
              onChange={(e) =>
                setSingleData({ ...SingleData, url: e.target.value })
              }
            />
            <InputTag
              labelText={"Collection Name"}
              star={true}
              padding={"8px"}
              fontSize={"12px"}
              maxLength={10000}
              placeholderType={"text"}
              value={SingleData?.collection_name}
              onChange={(e) =>
                setSingleData({
                  ...SingleData,
                  collection_name: e.target.value,
                })
              }
              warning={errors.collection_name}
            />
            <InputTag
              labelText={"Size"}
              star={true}
              padding={"8px"}
              fontSize={"12px"}
              maxLength={10000}
              placeholderType={"text"}
              value={SingleData?.size}
              onChange={(e) =>
                setSingleData({ ...SingleData, size: e.target.value })
              }
              warning={errors.size}
            />

            <div
              className={styles.Col_sm_sub4}
              style={{
                backgroundColor: mode ? "#232529" : "#fff",
                color: mode ? "#fff" : "#000",
              }}
            >
              <div
                className={styles.text_color}
                style={{ color: mode ? "#fff" : "#647298" }}
              >
                {" "}
                <span>Logo </span>{" "}
              </div>{" "}
              <div></div>
              <div>
                <ImageUploder
                  image={SingleData.logo}
                  setimage={(imge) =>
                    setSingleData({ ...SingleData, logo: imge })
                  }
                  selectText={"Select Master Image"}
                  error={errors.logo}
                />
              </div>
            </div>
            <div
              className={styles.Col_sm_sub4}
              style={{
                backgroundColor: mode ? "#232529" : "#fff",
                color: mode ? "#fff" : "#000",
              }}
            >
              <div
                className={styles.text_color}
                style={{ color: mode ? "#fff" : "#647298" }}
              >
                {" "}
                <span>Desktop Banner </span>{" "}
              </div>{" "}
              <div></div>
              {SingleData?.DeskTopBanner?.map((item, index) => (
                <div key={`Dexttop-${index}`}>
                  <div>
                    <ImageUploder
                      image={item.bannerImg}
                      setimage={(imageUrl) =>
                        handleImageChange("DeskTopBanner", index, imageUrl)
                      }
                      options={[
                        { label: "ITEM", value: "item" },
                        { label: "URL", value: "Url" },
                        { label: "N/A", value: "N/A" },
                      ]}
                      value={item.itemUrlType}
                      setoption={(selectedOption) => {
                        const updatedDeskTopBanner = [
                          ...SingleData.DeskTopBanner,
                        ];
                        updatedDeskTopBanner[index].itemUrlType =
                          selectedOption.value;
                        setSingleData({
                          ...SingleData,
                          DeskTopBanner: updatedDeskTopBanner,
                        });
                      }}
                      selectText={"Select Master Image"}
                      handeremove={() => HandelRemoveDeskTopBanner(index)}
                    />
                  </div>
                  <div>
                    <InputTag
                      padding={"8px"}
                      fontSize={"12px"}
                      maxLength={10000}
                      placeholderType={"text"}
                      placeholderText="URL.."
                      value={item.itemUrl}
                      onChange={(e) => {
                        const updatedDeskTopItemUrl = [
                          ...SingleData.DeskTopBanner,
                        ];
                        updatedDeskTopItemUrl[index].itemUrl = e.target.value;
                        setSingleData({
                          ...SingleData,
                          DeskTopBanner: updatedDeskTopItemUrl,
                        });
                      }}
                    />
                  </div>
                </div>
              ))}
              <div style={{ width: "120px", height: "auto" }}>
                <Button
                  buttonText={"ADD"}
                  buttonBgColor={"#4164E3"}
                  buttonTextColor={"#fff"}
                  buttonIcon={<AddTO />}
                  // disabled={disabled}
                  disabledButtonTextColor={"#fff"}
                  disabledButtonBgColor={"#4164E3"}
                  buttonClick={addNewDeskTopBanner}
                />
              </div>
            </div>
            <div
              className={styles.Col_sm_sub4}
              style={{
                backgroundColor: mode ? "#232529" : "#fff",
                color: mode ? "#fff" : "#000",
              }}
            >
              <div
                className={styles.text_color}
                style={{ color: mode ? "#fff" : "#647298" }}
              >
                {" "}
                <span> Mobile Banner </span>{" "}
              </div>{" "}
              <div></div>
              {SingleData?.mobItemBanner?.map((item, index) => (
                <div key={`mobItem-${index}`}>
                  <div>
                    <ImageUploder
                      image={item.bannerImg}
                      setimage={(imageUrl) =>
                        handleImageChange("mobItemBanner", index, imageUrl)
                      }
                      options={[
                        { label: "ITEM", value: "item" },
                        { label: "URL", value: "Url" },
                        { label: "N/A", value: "N/A" },
                      ]}
                      selectText={"Select Master Image"}
                      value={item.itemUrlType}
                      setoption={(selectedOption) => {
                        const updatedDeskTopBanner = [
                          ...SingleData.mobItemBanner,
                        ];
                        updatedDeskTopBanner[index].itemUrlType =
                          selectedOption.value;
                        setSingleData({
                          ...SingleData,
                          mobItemBanner: updatedDeskTopBanner,
                        });
                      }}
                      handeremove={() => HandelRemoveMobItemBanner(index)}
                    />
                  </div>
                  <div>
                    <InputTag
                      padding={"8px"}
                      fontSize={"12px"}
                      maxLength={10000}
                      placeholderType={"text"}
                      placeholderText="URL.."
                      value={item.itemUrl}
                      onChange={(e) => {
                        const updatedDeskTopItemUrl = [
                          ...SingleData.mobItemBanner,
                        ];
                        updatedDeskTopItemUrl[index].itemUrl = e.target.value;
                        setSingleData({
                          ...SingleData,
                          mobItemBanner: updatedDeskTopItemUrl,
                        });
                      }}
                    />
                  </div>
                </div>
              ))}
              <div style={{ width: "120px", height: "auto" }}>
                <Button
                  buttonText={"ADD"}
                  buttonBgColor={"#4164E3"}
                  buttonTextColor={"#fff"}
                  buttonIcon={<AddTO />}
                  disabledButtonTextColor={"#fff"}
                  disabledButtonBgColor={"#4164E3"}
                  buttonClick={addNewMobileBanner}
                />
              </div>
            </div>
          </div>

          {/* col - 2 */}
          <div
            className={styles.Col_sm1}
            style={{
              backgroundColor: mode ? "#232529" : "#fff",
              color: mode ? "#fff" : "#000",
            }}
          >
            <div>
              <InputTag
                labelText={"Collection Title"}
                padding={"8px"}
                fontSize={"12px"}
                maxLength={10000}
                placeholderType={"text"}
                required={true}
                star={true}
                value={SingleData.title}
                onChange={(e) =>
                  setSingleData({ ...SingleData, title: e.target.value })
                }
                warning={errors.title}
              />
            </div>
            <div>
              <InputTag
                labelText={"Base Price"}
                padding={"8px"}
                fontSize={"12px"}
                maxLength={10000}
                placeholderType={"number"}
                required={true}
                star={true}
                value={SingleData.mrp}
                onChange={(e) =>
                  setSingleData({ ...SingleData, mrp: e.target.value })
                }
                warning={errors.mrp}
              />
            </div>
            {loading.getTypeloading ? (
              <Skeleton lines={1} thickness={4} />
            ) : (
              <div className={styles.Add_select_type}>
                {SingleData?.type_name?.map((acc, i) => (
                  <div className={styles.Add_select_type2} key={i}>
                    <div className={styles.Add_select_type21}>
                      <VerticalDropDown2
                        dropDownText={"--Select--"}
                        label={"Select Type"}
                        height={"37px"}
                        fontSize={"12px"}
                        options={ProductType.filter(
                          (item) => !SingleData.type_name.some(type => type?.value === item?.type_name)
                        ).map((item) => ({
                          label: item?.type_name,
                          value: item?.type_name,
                        }))}
                        onchange={(label) => {
                          const newSelectedTypes = [...SingleData.type_name];
                          newSelectedTypes[i] = label;
                          setSingleData({
                            ...SingleData,
                            type_name: newSelectedTypes,
                          });
                        }}

                        value={acc}
                      />
                    </div>
                    <div
                      className={styles.Add_select_type22}
                      onClick={() => handleRemoveAccessory(i)}

                    >
                      <DeleteTo />
                    </div>
                  </div>
                ))}
              </div>
            )}

            <div>
              <div style={{ width: "120px", height: "auto" }}>
                <Button
                  buttonText={"ADD"}
                  buttonBgColor={"#4164E3"}
                  buttonTextColor={"#fff"}
                  buttonIcon={<AddTO />}
                  disabled={ProductType.length === SingleData.type_name.length ? true : false}

                  disabledButtonTextColor={"#fff"}
                  disabledButtonBgColor={"#ccc"}
                  buttonClick={handleAddAccessory}
                />
              </div>
            </div>
            <div>
              <InputTextArea
                lableText={"Product Description (Optional)"}
                value={SingleData.description}
                onChange={(e) =>
                  setSingleData({ ...SingleData, description: e.target.value })
                }
              />
            </div>
            <div className={styles.Redio_type_btn_con}>
              <div>
                Status<span style={{ color: "red" }}>*</span>{" "}
              </div>
              <div className={styles.redio_btn_div}>
                <div>
                  <InputRedio
                    lableText={"Yes"}
                    name={"OnlineVisible"}
                    checked={SingleData?.status === "Active"}
                    onChange={() =>
                      setSingleData({ ...SingleData, status: "Active" })
                    }
                  // disabled={disabled}
                  />
                </div>
                <div>
                  <InputRedio
                    lableText={"No"}
                    name={"OnlineVisible"}
                    checked={SingleData?.status === "Disable"}
                    onChange={() =>
                      setSingleData({ ...SingleData, status: "Disable" })
                    }
                  // disabled={disabled}
                  />
                </div>
                <div className={styles.redio_btn_div_err}>
                  {errors.status && (
                    <span style={{ fontSize: "12px", fontWeight: "400" }}>
                      {errors.status}
                    </span>
                  )}
                </div>
              </div>
            </div>
          </div>
          {/* col - 3 */}
          <div
            className={styles.Col_sm2}
            style={{
              backgroundColor: mode ? "#232529" : "#fff",
              color: mode ? "#fff" : "#000",
            }}
          >
            <div>
              <InputTag
                labelText={"Meta Title"}
                star={true}
                padding={"8px"}
                fontSize={"12px"}
                maxLength={10000}
                placeholderType={"text"}
                required={true}
                value={SingleData.metaTitle}
                onChange={(e) =>
                  setSingleData({ ...SingleData, metaTitle: e.target.value })
                }
                warning={errors.metaTitle}
              />
            </div>
            <div>
              <InputTextArea
                // star={true}
                // ErrorText={"Character limit 50-160"}
                lableText={"Meta Description (Optional)"}
                value={SingleData.metaDescription}
                onChange={(e) =>
                  setSingleData({
                    ...SingleData,
                    metaDescription: e.target.value,
                  })
                }
              />
            </div>
            <div>
              <KeyWordGen
                lableText={"Keywords"}
                star={true}
                words={SingleData.metaKeywords}
                setWords={(e) =>
                  setSingleData({ ...SingleData, metaKeywords: e })
                }
                errorText={errors.metaKeywords}
              />
            </div>
            <div>
              <KeyWordGen
                lableText={"Focus Keywords"}
                star={true}
                words={SingleData.focusKeyword}
                setWords={(e) =>
                  setSingleData({ ...SingleData, focusKeyword: e })
                }
                errorText={errors.focusKeyword}
              />
            </div>
          </div>
        </div>

        {/* </form> */}
      </div>
    </div>
  );
};

export default AddCollection;
